const logo = () => {
  return {
    to: "/uzb",
    image: {
      header: "3mBXOvvW4gFyzEfJJnCV3f.svg",
      footer: "2-G_o0P0-zlS4gxoGSgx4D.svg"
    }
  };
};

const langs = () => {
  return [{ locale: "ru" }, { locale: "uz" }, { locale: "en" }];
};

const meta = banner => {
  return {
    logo: logo(),
    description: {
      to: "/uzb",
      banner
    },
    API: process.env.VUE_APP_UZ,
    langs: langs(),
    mask: "+### (##) ### - ## - ##"
  };
};

export default {
  path: "/uzb",
  children: [
    {
      path: "/uzb/post=:post",
      name: "helpcenter.project",
      meta: meta("PostBanner")
    }
  ],
  name: "helpcenter.project",
  meta: meta("ProjectBanner"),
  component: () => import("@/views/Project.vue")
};
